export default __webpack_public_path__ + "static/media/BuildingCreative.20936299.jpg";